import { ImageBlock } from '@travelwin/cms/types';

import { ImageMedia } from '../ImageMedia';
import { RichTextLink } from '../RichTextLink';

export const ImageFigure = ({ block }: { block: ImageBlock }) => {
  const img = <ImageMedia media={block.media} loading="lazy" />;

  const element =
    block.linkType === 'custom' && block.url ? (
      <RichTextLink url={block.url} newTab={block.newTab}>
        {img}
      </RichTextLink>
    ) : (
      img
    );

  return <figure>{element}</figure>;
};
